/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import SingleTimer from "./single";
import { useJourney } from "../use-utils";
var Timer = function Timer(_ref) {
  var index = _ref.index,
    error = _ref.error,
    value = _ref.value,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '150px' : _ref$width,
    _onChange = _ref.onChange;
  var timer = value ? value.split(':') : ['00', '00'];
  return /*#__PURE__*/React.createElement(Row, {
    style: {
      maxWidth: width
    }
  }, /*#__PURE__*/React.createElement(SingleTimer, {
    value: value,
    onChange: function onChange(val) {
      _onChange(val);
    }
  }));
};
export default Timer;